import { AllowFeature } from 'app/model/feature/allow-feature.model';

export class InternalOrderFeature extends AllowFeature {
    label: InternalOrderLabel;
    placeholder: InternalOrderPlaceholder;

    constructor(featureData: any = undefined) {
      const { required } = featureData || { required: undefined };
      const { display } = featureData || { display: undefined };
      const { label } = featureData || { label: undefined };
      const { placeholder } = featureData || { placeholder: undefined };
      const isDisplayed = display === 'false' ? false : true;
      const isRequired = required === 'true' ? true : false;
      super(isRequired, isDisplayed);
      if (isDisplayed) {
          this.label = new InternalOrderLabel(label);
          this.placeholder = new InternalOrderPlaceholder(placeholder);
      }
    }
}

export class InternalOrderLabel {
    en: string;
    th: string;
    constructor(label: any = undefined) {
        this.en = label && label.en;
        this.th = label && label.th;
    }
}

export class InternalOrderPlaceholder {
    en: string;
    th: string;
    constructor(placeholder: any = undefined) {
        this.en = placeholder && placeholder.en;
        this.th = placeholder && placeholder.th;
    }
}



// WEBPACK FOOTER //
// ./src/app/model/feature/internal-order-feature.model.ts